export default __webpack_public_path__ + "static/media/image-todo.a32c78f5.jpg";